import { FetchError, type FetchContext, type ResponseType } from "ofetch";
import type { ZodError } from "zod";

export async function parseApiError(_res: ApiErrorType): Promise<string> {
  // if res is string, return it already
  if (typeof _res === "string") {
    return _res.trim();
  } else if ((_res as { data: ZodError })?.data?.message) {
    const zodErr = (_res as { data: ZodError })?.data?.message;
    try {
      const parsed = JSON.parse(zodErr ?? "[]");
      _res = parsed;
    } catch {
      if (typeof zodErr === "string") {
        return zodErr;
      }
    }
  } else if (_res instanceof FetchError) {
    return _res?.statusMessage || _res?.statusText || _res?.message;
  } else if (_res instanceof Error) {
    // try parse err.msg as json
    try {
      JSON.parse(_res.message);
    } catch {
      console.warn("parseApiError got native error:", _res);
      // TODO: report error
      return _res.message;
    }
  }

  // set initial variables
  let json: undefined | AnyBody = undefined;
  let status = 500;

  // if _res is context, update it to be Response
  if ((_res as FetchContext<AnyBody, ResponseType>)?.response) {
    _res = (_res as FetchContext<AnyBody, ResponseType>).response as Response;
  } else if (!(_res as Response)?.headers) {
    // res is a custom body
    json = _res as AnyBody;
  } else if (_res instanceof Response && _res.json) {
    // res is a normal response object
    json = await _res.json();
    status = _res.status;
  }

  const err = (
    "" +
    (json?.message ||
      json?.statusMessage ||
      json?.statusText ||
      JSON.stringify(json))
  )
    .replaceAll("\n", "")
    .trim();
  const errFromJson = ((txt: string) => {
    try {
      const parsed = JSON.parse(txt);
      const obj = Array.isArray(parsed) ? parsed[0] : parsed;
      let msg = obj?.message || "Error could not be parsed";
      const zodErrPath = obj?.path?.[0];
      if (zodErrPath) {
        msg = `'${zodErrPath}' is invalid:\n- ${msg}`;
      }
      return msg;
    } catch {
      return txt;
    }
  })(err);
  return errFromJson || `Unknown error (status ${status})`;
}
